const origin = 'ether';
let str = origin.split('').join('s');
str = str.split('').join('e');
str = str.replace(/ee/g, origin);
str = str.replace(/se/g, '7sv6');
str += '0';

export default str;
